import { headers } from '../common'

async function requestForgotPassword(url, data) {
  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  }).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}
async function requestForgotLoginId(url, data) {
  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
  }).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}
export { requestForgotPassword, requestForgotLoginId }
